import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import newLogo from '../../assets/images/tmov-logo-vgr.svg';
import { Container, Imagem } from './styles';

function LogoVgr({ linkTo }) {
  return <Container>
    <Link to={linkTo}>
      <Imagem alt="Tmov Vgr" src={newLogo} />
    </Link>
         </Container>;
}

LogoVgr.propTypes = {
  size: PropTypes.string,
  linkTo: PropTypes.string,
};

LogoVgr.defaultProps = {
  size: 'md',
  linkTo: '',
};

export default LogoVgr;
